import {
  SET_SELECTED_COUNTRY,
  SET_SELECTED_BRAND,
  SET_SELECTED_MENU,
} from "./actionTypes"

export const setSelectedCountry = country => ({
  type: SET_SELECTED_COUNTRY,
  payload: country,
})

export const setSelectedBrand = brand => ({
  type: SET_SELECTED_BRAND,
  payload: brand,
})

export const setSelectedMenu = menu => ({
  type: SET_SELECTED_MENU,
  payload: menu,
})
